import { Component, Input, ViewChild } from '@angular/core';
import { ConfigService } from '../shared/config.service';
import { LanguageRoutingComponent } from '../shared/language-routing.component';


@Component({
    selector: 'admin-header',
    template: require('./partials/admin-header.component.html'),
})
export class AdminHeaderComponent {
    // @ViewChild('myProfile') userProfile: UserProfile

    @Input() lgRouting: LanguageRoutingComponent;
    @Input() loggedInUser: string;
    // @Input() currentLanguage: string;
    // @Input() resourcePath: string;
    // @Input() lgRoutingCallback: Function;

    constructor(public config: ConfigService) {
    }
    
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-header.component.ts